import React from 'react';

import { InputWithError, IntegerCounterInput } from './imports';

export default function GuidePax(props) {
  return <InputWithError Type={IntegerCounterInput} name="pax" {...props} />;
}
